import React, { useEffect, useState } from "react";
import AdminShell from "@/components/AdminShell";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { adminAuth } from "@/lib/api";
import { Users, ClipboardList, FileText, Pill, CalendarClock, Loader2, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ Authorization: `Bearer ${adminAuth.getToken()}` });

export default function AdminClinic() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/clinic/admin/summary`, { headers: auth() });
        setSummary(r.data);
      } catch (e) {
        if (e?.response?.status === 401) navigate("/admin/login?next=/admin/clinic");
        else toast.error("Load failed");
      } finally { setLoading(false); }
    })();
  }, [navigate]);

  const cards = [
    { to: "/admin", icon: Users, label: "Clients", count: summary?.clients, sub: "Legacy clinical clients" },
    { to: "/admin", icon: ClipboardList, label: "Assessments", count: summary?.assessments, sub: "KCIS adaptive sessions" },
    { to: "/admin/kcis-adaptive-reporting", icon: FileText, label: "Reports", count: "", sub: "KCIS reporting" },
    { to: "/admin/clinic/protocols", icon: Pill, label: "Protocols", count: summary?.protocols, sub: `${summary?.protocols_active || 0} active` },
    { to: "/admin", icon: CalendarClock, label: "Follow-Ups", count: summary?.followups_today, sub: "Follow-up tracking" },
  ];

  return (
    <AdminShell door="clinic" title="Clinic Hub">
      <div data-testid="admin-clinic-page">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {cards.map((c) => (
              <Link key={c.label} to={c.to} className="rounded-2xl bg-white border border-slate-200 p-5 hover:border-purple-300 hover:shadow-sm transition" data-testid={`clinic-card-${c.label.toLowerCase()}`}>
                <div className="flex items-start justify-between">
                  <div className="w-10 h-10 rounded-xl bg-purple-50 flex items-center justify-center"><c.icon className="w-5 h-5 text-purple-900" /></div>
                  <ArrowRight className="w-4 h-4 text-slate-400" />
                </div>
                <div className="mt-4 font-display text-xl text-slate-900">{c.label}</div>
                <div className="text-xs text-slate-500">{c.sub}</div>
                {c.count !== "" && c.count !== undefined && (
                  <div className="text-3xl font-display text-purple-900 mt-3">{c.count ?? "—"}</div>
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
    </AdminShell>
  );
}
